import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import adminuser from './modules/adminuser'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    app,
    adminuser
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js